import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import jwt_decode from "jwt-decode";
import CloseIcon from '@mui/icons-material/Close';
import Paper from '@mui/material/Paper';
import PreviewTwoToneIcon from '@mui/icons-material/PreviewTwoTone';
import DownloadForOfflineTwoToneIcon from '@mui/icons-material/DownloadForOfflineTwoTone';
import { useEffect, useRef, useState } from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Link, TextField, Typography } from '@mui/material';
import format from 'format-number'
import DocumentosAdjuntosPagoGuardados from './DocumentosAdjuntosPagoGuardados';
import DocumentosAdjuntosSolicitud from "./DocumentosAdjuntosSolicitud";


const columns = [
    { id: 'proyecto', label: 'Proyecto', width: 150, align: 'justify' },
    { id: 'partida', label: 'Partida', width: 150, align: 'justify' },
    { id: 'estado', label: 'Estado', width: 150, align: 'justify' },
    { id: 'monto', label: 'Monto', width: 50, align: 'right' }
];

export const colocarNombre = (ruta) => {
    if (!ruta || ruta === '')
        return ''
    const indice = Number(ruta.indexOf("pago")) + 9
    return ruta.slice(indice)

}

const colocarNombreFactura = (ruta) => {
    if (!ruta || ruta === '')
        return ''
    const indice = Number(ruta.indexOf("factura")) + 9
    return ruta.slice(indice)

}
let idContratoGuardado

const mostrarDocumento = async (value, tipo) => {
    //console.log(`value en desplegarDocumentoPDF ${value}`)
    await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/mostrarFactura`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "x-access-token": sessionStorage.getItem('token'),
            "perfil": sessionStorage.getItem('perfil'),
            "ruta": value,
            "tipo": tipo
        }
    }
    ).then((res) => res.blob())
        .then((blob) => { // RETRIEVE THE BLOB AND CREATE LOCAL URL
            var _url = window.URL.createObjectURL(blob);
            window.open(_url, "_blank").focus(); // window.open + focus
        }).catch((err) => {
            console.error(err);
        });
}


export default function PagosListado(props) {
    const { idContrato, pagos, partidas, setPagos, solicitud, documentos, setDocumentos, setProyecto, setPartida,
        setPartidasProyecto, setMonto, setPago, pago, setLimpiar, pagosEliminados, setPagosEliminados } = props;
    /*const [pago, setPago] = useState({
        monto: null, concepto: null,
        documentos: new FormData(), rutaPDF: null, rutaXML: null, idSolicitud: null, observaciones: null,
        documentosAnexos: null, descripcion: null, fecha: null
    })*/
    const formulario = useRef(null)
    const [errorDocumentoPDF, setErrorDocumentoPDF] = useState(false)
    const [helperTextDocumentoPDF, setHelperTextDocumentoPDF] = useState('')
    const [errorDocumentoXML, setErrorDocumentoXML] = useState(false)
    const [helperTextDocumentoXML, setHelperTextDocumentoXML] = useState('')
    const [loading, setLoading] = useState(false);
    //const [partida, setPartida] = useState(null);
    const [rutaPDF, setRutaPDF] = useState(false)
    const [rutaXML, setRutaXML] = useState(false);
    const [open, setOpen] = useState(false);
    const [openMensaje, setOpenMensaje] = useState(false);
    const [mensaje, setMensaje] = useState('');
    const token = sessionStorage.getItem('token')
    const decoded = jwt_decode(token);
    const idResponsable = decoded.id;
    const [anio, setAnio] = useState(null)
    const [severity, setSeverity] = useState('error')
    useEffect(() => {
        (async () => {
            if (solicitud) {
                const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/contrato/solicitud/${solicitud.id}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": sessionStorage.getItem('token'),
                        "perfil": sessionStorage.getItem('perfil')
                    }
                })
                const solicitudLeida = await res.json()

                if (res.status === 403) {
                    sessionStorage.clear();
                    window.location.replace(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_FRONTEND_PORT_LOGIN}/logout`)
                }


                setPagos(solicitudLeida.contratos[0].pagoContratos)
            }

        })();
        // eslint-disable-next-line
    }, []);

    idContratoGuardado = idContrato
    let total = Number(0)

    const handleFormulario = () => {
        if (formulario.current) {
          
            formulario.current.click()
        }
      };

    const handleUpdate = async (e) => {
        e.preventDefault()
        setLoading(true)

        if (!rutaPDF) {
            if (pago.documentos.get('PDF')) {
                const archivoPDF = new FormData();
                archivoPDF.append('factura', pago.documentos.get('PDF'));
                const resUploadPDF = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/uploadFacturas`, {
                    method: "POST",
                    body: archivoPDF
                })
                const rutaPDF = (await resUploadPDF.json()).ruta
                pago.rutaPDF = rutaPDF
            }
        }
        if (!rutaXML) {
            if (pago.documentos.get('XML')) {
                const archivoXML = new FormData();
                archivoXML.append('factura', pago.documentos.get('XML'));
                const resUploadXML = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/uploadFacturas`, {
                    method: "POST",
                    body: archivoXML
                })
                const rutaXML = (await resUploadXML.json()).ruta
                pago.rutaXML = rutaXML
            }
        }


        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/contrato/pago`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            },
            body: JSON.stringify({
                anio,
                pago,
                documentos
            })
        })


        const data = await res.json()

        if (res.status === 200) {
            setSeverity('success')
            setPago(data.pago)
            const comentario = { idSolicitud: solicitud.id, estado: solicitud.estado, comentarios: `Se solicita iniciar los trámites para pago relacionado con la solicitud de contrato ${solicitud.folio} ${pago.descripcion ? '\nDescripción: ' + pago.descripcion : ''} ${pago.observaciones ? '\nObservaciones: ' + pago.observaciones : ''}`, idResponsable, paraAsistente: true, paraJefe: false }
            await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/${solicitud.id}/${sessionStorage.getItem('idEntidad')}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                },
                body: JSON.stringify(comentario)
            })
            setLimpiar(true)
            setDocumentos([])
        }
        else
            setSeverity('error')

        if (data.message) {
            setOpenMensaje(true)
            setMensaje(data.message)
            setLoading(false)
            return
        }
        else {
            setOpenMensaje(true)
            setMensaje("Se actualizó la solicitud.")
        }
        setLoading(false)

    }

    const handleClickOpen = (pago) => {
        setPago({ ...pago, documentos: new FormData() })
        //console.log(JSON.stringify(pago))
        setOpen(true);
    };

    const cargarDatosFormulario = async (id) => {
        //console.log(`Dentro de cargarDatosFormulario`)
        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/contrato/datosPago/${id}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            }
        })
        const { pago, proyecto } = await res.json()
        setPago({ ...pago })
        setProyecto(proyecto)
        const partidaSeleccionada = proyecto.partidaProyectos.filter(partida => Number(partida.idPartidaProyecto) === Number(pago.idPartidaProyecto))[0]
        setPartidasProyecto(proyecto.partidaProyectos)
        //console.log(`partidaSeleccionada ${JSON.stringify(partidaSeleccionada)}`)
        //console.log(`partidas ${JSON.stringify(partidas)}`)
        setPartida(partidaSeleccionada)
        setMonto(pago.monto)
    }

    const handleClose = () => {
        setOpen(false);
    }

    const handleDelete = async (registro) => {
        //console.log(`registro ${JSON.stringify(registro)}`)
        const partidaExiste = partidas.filter(pago => Number(pago.idPartidaProyecto) === Number(registro.idPartidaProyecto))
        if (partidaExiste && partidaExiste[0]) {
            partidaExiste[0].monto = (Number(partidaExiste[0].monto ? partidaExiste[0].monto : 0) - Number(registro.monto)).toFixed(2)
            //console.log(`partidaExiste[0].monto ${partidaExiste[0].monto} al eliminar`)
        }

        //console.log(`partidas ${JSON.stringify(partidas)}`)
        if (registro.id) {
            const pagosListado = pagos.filter(pago => Number(pago.id) !== Number(registro.id))
            setPagos(pagosListado)
            pagosEliminados.push(registro)
            setPagosEliminados(pagosEliminados)
            //console.log(`stringify pagos ${JSON.stringify(pagosListado)}`)
            //console.log(`stringify pagosEliminados ${JSON.stringify(pagosEliminados)}`)
        }
        else
            setPagos(pagos.filter(pago => Number(pago.indice) !== Number(registro.indice)))
        /*
        transferenciasEliminadas.push(registro.id)
        setHelperTextPartidaRepetida('')
        setErrorPartidaRepetida(false)*/
        total = Number(total) - Number(registro.monto)
    }

    return (
        <>
            <Grid item xs={12} container justifyContent='stretch' spacing={5}>
                <Grid item xs={12} sm={12}>
                    <TableContainer sx={{ maxHeight: 440 }}>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow key='encabezado'>
                                    <TableCell key='ninguna' align="center" colSpan={6}>
                                        Pagos
                                    </TableCell>
                                </TableRow>
                                <TableRow key='encabezado2'>
                                    {columns.map((column) => {
                                        return (
                                            <TableCell
                                                key={column.id}
                                                align={column.align}
                                                style={{ top: 57, minWidth: column.minWidth }}
                                            >
                                                {column.label}
                                            </TableCell>
                                        )
                                    })}<TableCell style={{ top: 57 }}></TableCell>
                                    <TableCell style={{ top: 57 }}></TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {pagos.length > 0 ? pagos
                                    .map((row) => {
                                        return (
                                            <TableRow hover role="checkbox" tabIndex={-1} key={row.partida.idPartidaProyecto}>
                                                {columns.map((column) => {
                                                    const value = row[column.id];
                                                    if (column.id === 'monto')
                                                        total = Number(total) + Number(value)
                                                    let partidaMostrar = ''
                                                    let proyectoMostrar = ''

                                                    return (
                                                        <TableCell key={column.id} align={column.align}>
                                                            {column.id === 'monto' ? (format({ prefix: '$' })(value)) : value}
                                                        </TableCell>
                                                    );
                                                })}
                                                {/*<TableCell><Button variant='contained' style={{ marginLeft: 5, backgroundColor: 'rgb(224, 224, 224)', color: 'rgba(0, 0, 0, 0.87)' }} onClick={() => handleUpdate(row)}>{'Editar'}</Button></TableCell>*/}
                                                {row.estado ? row.estado !== 'tramiteConcluido' && (solicitud && !solicitud.estado.startsWith('ajustes')) && row.estado !== 'fechaPago' ? <TableCell><Button variant='contained' style={{ marginLeft: 5, width: '100%' }} color='primary' onClick={() => { handleClickOpen(row) }}>{'Editar trámite'}</Button></TableCell> : <TableCell></TableCell> : solicitud && solicitud.estado !== 'ajustesJefe' && solicitud.estado !== 'ajustesAsistente' && solicitud.estado !== 'cancelada' && solicitud.estado !== 'concluida' && solicitud.id ? <TableCell><Button variant='contained' style={{ marginLeft: 5, backgroundColor: "darkred", color: 'white', width: '100%' }} onClick={() => { handleClickOpen(row) }}>{'Solicitar pago'}</Button></TableCell> :
                                                    <TableCell><Button variant='contained' style={{ marginLeft: 5, backgroundColor: "darkred", color: 'white', width: '100%' }} onClick={() => handleDelete(row)}>{'Eliminar'}</Button></TableCell>
                                                }
                                                {solicitud && solicitud.estado.startsWith('ajustes') && (!row.estado || row.estado === 'enAjustes') && row.id ? <TableCell><Button variant='contained' style={{ marginLeft: 5, width: '100%' }} color='secondary' onClick={async () => { await cargarDatosFormulario(row.id) }}>Modificar pago</Button></TableCell> : <TableCell></TableCell>}
                                            </TableRow>
                                        );
                                    }) : <TableRow hover role="checkbox" tabIndex={-1} >

                                    <TableCell align='center'>
                                        No hay pagos registrados
                                    </TableCell>

                                </TableRow>}
                                <TableRow hover role="checkbox" tabIndex={-1} >
                                    <TableCell align='right' colSpan={4}>
                                        <strong>Total: {format({ prefix: '$' })(total)}</strong>
                                    </TableCell>
                                    <TableCell colSpan={2}></TableCell>

                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>

            </Grid>
            <Dialog open={open} fullWidth={true}
                maxWidth='xl' >

                <DialogTitle>Tramitar pago</DialogTitle>


                <DialogContent style={{ backgroundColor: '#FFFEED' }}>

                    <Grid item xs={12} sm={12}>
                        <Paper variant="elevation" marginTop={5}>
                            <Grid container spacing={2} paddingX={2}>
                                <Grid item xs={12} sm={12}>
                                    <form onSubmit={handleUpdate}>
                                        <Grid container justifyContent='stretch' spacing={5} style={{ marginTop: 5 }}>
                                            <Grid item xs={12}>
                                                <TextField label={'Factura PDF'} id='documentoPDF' name='documentoPDF' focused required={!pago.rutaPDF} type='file' accept="application/pdf" helperText={helperTextDocumentoPDF} error={errorDocumentoPDF} onChange={async (event) => {
                                                    if (pago.documentos)
                                                        pago.documentos.delete('PDF')
                                                    const file = event.target.files[0]
                                                    if (event.target.value) {
                                                        if (event.target.value.endsWith(".PDF") || event.target.value.endsWith(".pdf")) {
                                                            setHelperTextDocumentoPDF('')
                                                            setErrorDocumentoPDF(false)
                                                        }
                                                        else {
                                                            setHelperTextDocumentoPDF('Formato de archivo no válido, se requiere PDF')
                                                            setErrorDocumentoPDF(true)
                                                            return
                                                        }
                                                        if (file.size > 5242880) {
                                                            setHelperTextDocumentoPDF('El tamaño del archivo debe ser menor a 5MB')
                                                            setErrorDocumentoPDF(true)
                                                            return
                                                        }
                                                        else {
                                                            setHelperTextDocumentoPDF('')
                                                            setErrorDocumentoPDF(false)
                                                        }

                                                        setHelperTextDocumentoPDF('')
                                                        setErrorDocumentoPDF(false)

                                                        let regex = /([^-\w.]*)/gm;
                                                        const nombreArchivo = file.name.replace(regex, '');
                                                        const resVerificar = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/verificarPDF`, {
                                                            method: "GET",
                                                            headers: {
                                                                "nombre": nombreArchivo,
                                                                "carpeta": "facturas"
                                                            }
                                                        })
                                                        if (resVerificar.status === 200) {
                                                            //setErrorDocumentoPDF(true)
                                                            setHelperTextDocumentoPDF('Ya existe un archivo registrado con ese nombre. Si no lo subiste tú en un intento anterior por favor renombra tu archivo y trata de subirlo de nuevo, de lo contrario se colocará el enlace al archivo existente')
                                                            const data = await resVerificar.json()
                                                            //console.log(`data ${data.ruta}`)
                                                            setPago({ ...pago, rutaPDF: data.ruta })
                                                            setRutaPDF(true)
                                                            return
                                                        }
                                                        else {
                                                            setPago({ ...pago, rutaPDF: null })
                                                            setRutaPDF(false)
                                                            setErrorDocumentoPDF(false)
                                                            setHelperTextDocumentoPDF('')
                                                        }
                                                    }
                                                    //console.log(`Files[0] ${file.name}`)
                                                    pago.documentos.append('PDF', file)
                                                }} sx={{ width: '100%' }} />
                                                {pago.rutaPDF ?
                                                    <Link style={{ cursor: 'pointer' }} onClick={async () => { await mostrarDocumento(pago.rutaPDF, 'pdf') }} target='_blank'>{colocarNombreFactura(pago.rutaPDF)}<PreviewTwoToneIcon></PreviewTwoToneIcon></Link> :
                                                    <></>
                                                }
                                            </Grid>

                                            <Grid item xs={12}>
                                                <TextField label='Factura XML' id='documentoXML' name='documentoXML' focused required={!pago.rutaXML} type='file' accept="application/xml" helperText={helperTextDocumentoXML} error={errorDocumentoXML} onChange={async (event) => {
                                                    if (pago.documentos)
                                                        pago.documentos.delete('XML')
                                                    const file = event.target.files[0]
                                                    if (event.target.value) {
                                                        if (event.target.value.endsWith(".XML") || event.target.value.endsWith(".xml")) {
                                                            setHelperTextDocumentoXML('')
                                                            setErrorDocumentoXML(false)
                                                        }
                                                        else {
                                                            setHelperTextDocumentoXML('Formato de archivo no válido, se requiere XML')
                                                            setErrorDocumentoXML(true)
                                                            return
                                                        }
                                                        if (file.size > 5242880) {
                                                            setHelperTextDocumentoXML('El tamaño del archivo debe ser menor a 5MB')
                                                            setErrorDocumentoXML(true)
                                                            return
                                                        }
                                                        else {
                                                            setHelperTextDocumentoXML('')
                                                            setErrorDocumentoXML(false)
                                                        }

                                                        setHelperTextDocumentoXML('')
                                                        setErrorDocumentoXML(false)

                                                        let regex = /([^-\w.]*)/gm;
                                                        const nombreArchivo = file.name.replace(regex, '');
                                                        const resVerificar = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/verificarFacturaXML`, {
                                                            method: "GET",
                                                            headers: {
                                                                "nombre": nombreArchivo,
                                                                "carpeta": "facturas"
                                                            }
                                                        })
                                                        if (resVerificar.status === 200) {
                                                            setHelperTextDocumentoXML('Ya existe un archivo registrado con ese nombre. Si no lo subiste tú en un intento anterior por favor renombra tu archivo y trata de subirlo de nuevo, de lo contrario se colocará el enlace al archivo existente')
                                                            const data = await resVerificar.json()
                                                            //console.log(`data ${data.ruta}`)
                                                            setPago({ ...pago, rutaXML: data.ruta })
                                                            setRutaXML(true)
                                                            return
                                                        }
                                                        else {
                                                            setPago({ ...pago, rutaXML: null })
                                                            setRutaXML(false)
                                                            setErrorDocumentoXML(false)
                                                            setHelperTextDocumentoXML('')
                                                        }
                                                    }
                                                    //console.log(`Files[0] ${file.name}`)
                                                    pago.documentos.append('XML', file)
                                                }} sx={{ width: '100%' }} />
                                                {pago.rutaXML ?
                                                    <Link href={`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/descargarDocumentoXML/${colocarNombreFactura(pago.rutaXML)}`} download={colocarNombreFactura(pago.rutaXML)}>{colocarNombreFactura(pago.rutaXML)}<DownloadForOfflineTwoToneIcon></DownloadForOfflineTwoToneIcon></Link> :
                                                    <></>
                                                }
                                            </Grid>

                                            <Grid item xs={12} sm={12}>
                                                <TextField label={`Observaciones del pago`} id='observaciones' name='observaciones' focused multiline maxRows={5} sx={{ width: '100%' }}
                                                    onChange={(e) => {
                                                        const valor = e.target.value
                                                        setPago({ ...pago, [e.target.name]: valor })
                                                    }
                                                    } value={pago.observaciones} />
                                            </Grid>
                                            <Grid item xs={12} sm={12}>
                                                <Typography component='div' style={{ color: 'rgb(156, 39, 176)', fontSize: '0.75rem' }}>{'Existen dos formas de publicar los documentos relacionados al pago:'}<br />
                                                    {'1. Si el documento es menor a 5 MB utilizar el formulario que aparece en la parte inferior de esta ventana, utilizando el scroll para poder visualizarla.'}<br />
                                                    {'2. Para facilitar el proceso de publicación, si son más de 3 los documentos a registrar, o si éstos superan el tamaño permitido de 5 MB, el usuario puede crear un DRIVE desde su cuenta de correo institucional y compartir el enlace con los documentos almacenados en él.'}
                                                </Typography><br />&nbsp;
                                                <TextField label={`Documentos anexos (enlace de Drive)`} id='documentosAnexos' name='documentosAnexos' focused type='url' maxRows={5} sx={{ width: '100%' }}
                                                    onChange={(e) => {
                                                        const valor = e.target.value
                                                        setPago({ ...pago, [e.target.name]: valor })
                                                    }
                                                    } value={pago.documentosAnexos} />
                                            </Grid>
                                            <Grid item xs={12} sm={12}>
                                                <TextField label={`Descripción de los documentos en Drive`} id='descripcion' name='descripcion' focused multiline maxRows={5} sx={{ width: '100%' }}
                                                    onChange={(e) => {
                                                        const valor = e.target.value
                                                        setPago({ ...pago, [e.target.name]: valor })
                                                    }
                                                    } value={pago.descripcion} />
                                            </Grid>
                                            <Grid item xs={12} sm={12}>
                                                {pago.documentoPagos && pago.documentoPagos.length > 0 ?
                                                    <DocumentosAdjuntosPagoGuardados pago={pago} setPago={setPago}></DocumentosAdjuntosPagoGuardados>
                                                    : <></>}
                                            </Grid>
                                        </Grid>
                                        <Grid item sx={{ marginY: 5 }}>
                                            <Button variant='contained' color='primary' type='submit' disabled={errorDocumentoPDF || errorDocumentoXML || loading} ref={formulario} style={{display: 'none'}}>
                                                Solicitar
                                            </Button>
                                        </Grid>
                                    </form>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                    <DocumentosAdjuntosSolicitud documentos={documentos} setDocumentos={setDocumentos} ventana={false} idAutor={idResponsable}></DocumentosAdjuntosSolicitud>
                </DialogContent>
                <DialogActions>
                    <Grid container spacing={2} paddingX={2}>
                        <Grid item xs={12} sm={8}>
                            <Box>
                                <Collapse in={openMensaje}>
                                    <Alert severity={severity}
                                        action={
                                            <IconButton
                                                aria-label="close"
                                                color="inherit"
                                                size="small"
                                                onClick={() => {
                                                    setOpenMensaje(false);
                                                }}
                                            >
                                                <CloseIcon fontSize="inherit" />
                                            </IconButton>
                                        }

                                    >
                                        {mensaje}
                                    </Alert>
                                </Collapse>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={4} sx={{ textAlign: 'right' }}>
                            <Button variant='contained' color='primary' type='button' disabled={errorDocumentoPDF || errorDocumentoXML || loading} onClick={handleFormulario}>
                                Solicitar
                            </Button>
                        
                            <Button variant='contained' style={{ backgroundColor: "darkgreen", color: 'white', marginLeft: 20 }} onClick={handleClose}>Cerrar Ventana</Button>
                        </Grid>
                    </Grid>
                </DialogActions>

            </Dialog>
        </>
    );
}